import useComplaintSearch from './useComplaintSearch'

export default useComplaintSearch
